import React from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from './home/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './home/HeroSection';
import { FeaturedProductLinesSection } from './home/FeaturedProductLinesSection';
import { ProductLinesSolutionsSection } from './home/ProductLinesSolutionsSection';
import { UsedMachinesSection } from './home/UsedMachinesSection';
import { EDMSection } from './home/EDMSection';
import { CNCMillingSection } from './home/CNCMillingSection';
import { CNCTurningSection } from './home/CNCTurningSection';
import { LaserCuttingSection } from './home/LaserCuttingSection';
import { AutomationSection } from './home/AutomationSection';
import { ProductLinesAvailableSection } from './home/ProductLinesAvailableSection';
import { AboutSection } from './home/AboutSection';
import { FinancingSection } from './home/FinancingSection';
import { AssociationsSection } from './home/AssociationsSection';
import { ContactHeaderSection } from './home/ContactHeaderSection';
import { ContactFormSection } from './home/ContactFormSection';
import { GetInTouchSection } from './home/GetInTouchSection';
export function HomePage() {
  return <div className="min-h-screen w-full bg-white" data-id="element-2822">
      <SeoBar data-id="element-2823" />
      <Header data-id="element-2824" />
      <main data-id="element-2825">
        <HeroSection data-id="element-2826" />
        <FeaturedProductLinesSection data-id="element-2827" />
        <ProductLinesSolutionsSection data-id="element-2828" />
        <UsedMachinesSection data-id="element-2829" />
        <EDMSection data-id="element-2830" />
        <CNCMillingSection data-id="element-2831" />
        <CNCTurningSection data-id="element-2832" />
        <LaserCuttingSection data-id="element-2833" />
        <AutomationSection data-id="element-2834" />
        <ProductLinesAvailableSection data-id="element-2835" />
        <AboutSection data-id="element-2836" />
        <FinancingSection data-id="element-2837" />
        <AssociationsSection data-id="element-2838" />
        <ContactHeaderSection data-id="element-2839" />
        <section className="pb-16 md:pb-24 bg-white" data-id="element-2840">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2841">
            <div className="grid lg:grid-cols-2 gap-12" data-id="element-2842">
              <ContactFormSection data-id="element-2843" />
              <GetInTouchSection data-id="element-2844" />
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-2845" />
    </div>;
}